import { render, staticRenderFns } from "./ClaimExpired.vue?vue&type=template&id=6a641b8e&scoped=true"
import script from "./ClaimExpired.vue?vue&type=script&lang=js"
export * from "./ClaimExpired.vue?vue&type=script&lang=js"
import style0 from "./ClaimExpired.vue?vue&type=style&index=0&id=6a641b8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a641b8e",
  null
  
)

export default component.exports